export const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY;
